import { useEffect, useState, useTransition } from "react";
import { useLocation } from "react-router-dom";

export default function useConcurrentTransition() {
    const location = useLocation();
    const [oldLocation, setOldLocation] = useState(location);
    const [, startTransition] = useTransition();

    useEffect(() => {
        setOldLocation((oldLocation) =>
            oldLocation.pathname !== location.pathname ||
                oldLocation.search !== location.search
                ? location
                : oldLocation
        );
    }, [location]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            startTransition(() => {
                setOldLocation(location);
            });
        }, 500);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [oldLocation]);

    return oldLocation;
}